import Loader from 'components/Loader'

import Container from './styles'

export default function Button({
  label,
  onClick,
  loading,
  className,
  ...rest
}) {
  return (
    <Container
      onClick={onClick}
      className={`${className ? className : ''} ${loading ? 'loading' : ''}`}
      {...rest}
    >
      {!loading ? label : <Loader inverse />}
    </Container>
  )
}
